firebird.controller('loadingPopupCtrl', [
    '$rootScope',
    '$scope',
    '$timeout',
    'attendeeService',
    'helperService',
    'logService',
    'meetingService',
    'contentService',
    'localizationService',
    function (
        $rootScope,
        $scope,
        $timeout,
        attendeeService,
        helperService,
        logService,
        meetingService,
        contentService,
        localizationService
    ) {
        var self = this;

        self.isHost = false;
        self.state = '';
        self.message = '';
        self.altMessage = '';
        self.type = '';
        self.messages = {};
        self.continousMessages = {};
        self.initialTimeout = null;
        self.matchType = false;
        self.timeoutArray = [];
        self.sfuScreenShareReconnecting = false;

        self.onStartLoading = onStartLoading;
        self.onStopLoading = onStopLoading;
        self.showMessage = showMessage;
        self.showContinousMessages = showContinousMessages;
        self.shouldShowContinousMessages = shouldShowContinousMessages;
        self.clearTimeoutArray = clearTimeoutArray;

        $scope.$on('content-initiating', onContentInitiating);
        $scope.$on('content-playing', onStopLoading);
        $scope.$on('fs-content-started', onStopLoading);
        $scope.$on('content-stopped', onStopLoading);
        $scope.$on('content-init-cancelled', onStopLoading);
        $scope.$on('content-status', onContentStatus);
        $scope.$on('on-air-mode-updating', onOnAirModeUpdating);
        $scope.$on('on-air-mode-updated', onOnAirModeUpdated);
        $scope.$on('sfu-screenshare-disconnected', onSfuScreenshareDisconnected);

        //HD ScreenShare
        $scope.$on('hd-screenshare-conf-call-connecting', onHDScreenShareConfCallConnecting);
        $scope.$on('hd-screenshare-fs-connection-complete', onHDScreenShareConfCallConnected);
        $scope.$on('hd-screenshare-conf-call-disconnected', onHDScreenShareConfCallDisconnected);

        init();

        ////////////////////////

        function init() {
            self.isHost = attendeeService.getIsHost();

            //These messages are in categorized arrays so that we can
            //potentially add more messages, which can be chosen at random.
            //
            //Hence the use of Math.random down below

            //Init messages
            self.messages.slides = [
                localizationService.translate('HEADER.LOADING_POPUP.SLIDES')
                //'Loading, your slides are.'
                //'Slides will be loaded shortly.'
                //
                //Should this array grow,
                //Math.random will choose a different message each time
            ];

            self.messages.video = [localizationService.translate('HEADER.VIDEO_IS_LOADING')];

            self.messages.screenshare = [localizationService.translate('HEADER.SCREEN_SHARE_IS_LOADING')];

            self.messages.hdScreenshare = [localizationService.translate('HEADER.LOADING_POPUP.HD_SCREEN_SHARE')];

            self.messages.general = [localizationService.translate('HEADER.LOADING_POPUP.GENERAL_LOADING')];

            self.messages.onAirMode = [localizationService.translate('HEADER.LOADING_POPUP.GO_ON_AIR')];

            //Continuous messages
            //If loading screen takes long, we show a series of messages
            self.continousMessages.hdScreenshare = [
                localizationService.translate('HEADER.LOADING_POPUP.HD_SCREEN_SHARE1'),
                localizationService.translate('HEADER.LOADING_POPUP.HD_SCREEN_SHARE2'),
                localizationService.translate('HEADER.LOADING_POPUP.HD_SCREEN_SHARE3'),
                localizationService.translate('HEADER.LOADING_POPUP.HD_SCREEN_SHARE4')
            ];
        }

        function onStartLoading(event, data, matchType) {
            self.matchType = matchType ? true : false;

            var isWebinar = meetingService.isWebinar();
            var isAttendee = attendeeService.getIsAttendee();

            if (isWebinar && isAttendee) {
                return;
            }

            // Show this loading popup
            self.state = 'show';

            logService.log('Starting loading pop-up', data);

            //If no type is passed, default to 'general' messages
            self.type = data && data.type ? data.type : 'general';
            if (data && data.type == 'screenshare' && data.isFilePlay) {
                self.type = 'video';
            }

            if (self.shouldShowContinousMessages()) {
                self.showContinousMessages();
            } else {
                self.showMessage();
            }

            $rootScope.$broadcast('loading-popup-started');

            digest();
        }

        function onStopLoading(e, data) {
            if (self.state !== 'show') {
                return;
            }

            if (
                (data && data.type == 'screenshare' && self.type == 'screenshare' && e.name == 'fs-content-started') ||
                (data && data.type == 'screenshare' && self.type == 'video' && e.name == 'content-playing')
            ) {
                // for SFU screenshare use content-playing and for SFU video file play use fs-content-started
                // as event to stop the popup.
                return;
            }

            if (self.sfuScreenShareReconnecting) {
                logService.log('loadingPopupCtrl - resetting sfuScreenShareReconnecting');
                self.sfuScreenShareReconnecting = false;
            }

            if (self.matchType) {
                //matchType is to ensure a loading popup doesn't get closed
                //by another event's onStopLoading execution
                //
                //Currently only using this for hdScreenshare
                if (data && data.type !== self.type) {
                    return;
                } else {
                    self.matchType = false;
                }
            }

            if (self.type === 'onAirMode') {
                //When going on-air, sometimes we stop content sharing, which
                //closes the On-Air loading popup...
                //
                //To keep the On-Air loading popup open throughout the content stopping,
                //we only allow the type 'onAirMode' to close it
                if (data && data.type !== 'onAirMode') {
                    return;
                }
            }

            logService.log('Stopping loading pop-up');

            self.state = 'hide';
            self.message = '';
            self.type = '';
            self.clearTimeoutArray();

            $rootScope.$broadcast('loading-popup-stopped');

            digest();

            //After the fadeout transition finishes (takes 1 second),
            //Reset state back to empty string to prevent
            //the pop-up container from blocking the feed
            $timeout(function () {
                if (self.state === 'hide') {
                    self.state = '';
                    digest();
                }
            }, 1000);
        }

        function showMessage() {
            var msgList = self.messages[self.type];
            self.message = msgList[Math.floor(Math.random() * msgList.length)];
        }

        function showContinousMessages() {
            var msgList = self.continousMessages[self.type];
            var delay = 3000;

            msgList.forEach(function (msg, index) {
                //Main idea: fade one message out while fading the other message in
                var to = $timeout(function () {
                    if (self.message) {
                        self.altMessage = msg;
                        self.message = '';
                    } else {
                        self.message = msg;
                        self.altMessage = '';
                    }
                    digest();
                }, delay * index);

                self.timeoutArray.push(to);
            });
        }

        function shouldShowContinousMessages() {
            //We can always use if/else or switch statements
            //if we want continous messages for other types
            return self.type === 'hdScreenshare';
        }

        function clearTimeoutArray() {
            if (self.timeoutArray && self.timeoutArray.length > 0) {
                self.timeoutArray.forEach(function (currentTimeout) {
                    $timeout.cancel(currentTimeout);
                });

                self.timeoutArray = [];
            }
        }

        function onContentStatus(e, data) {
            if (attendeeService.getAttendantId() !== data.requesterID) {
                return;
            }

            //If content is initiating, show loading view
            if (data.state === 'initiating') {
                if (!(data && data.type === 'screenshare' && self.sfuScreenShareReconnecting)) {
                    onStartLoading(e, data);
                }
            } else if (self.state === 'show') {
                onStopLoading();
            }
        }

        function onSfuScreenshareDisconnected(e, data) {
            //If content is initiating, show loading view (except for screenshare)
            if (data.value) {
                if (data.isFilePlay) {
                    self.onStartLoading(e, { type: 'video' });
                } else {
                    self.sfuScreenShareReconnecting = true;
                }
            } else {
                if (data.isFilePlay) {
                    self.onStopLoading(e, { type: 'video' });
                }
            }
        }

        function onOnAirModeUpdating() {
            self.onStartLoading({}, { type: 'onAirMode' });
        }

        function onOnAirModeUpdated(e, data) {
            self.onStopLoading({}, { type: 'onAirMode' });
        }

        function digest() {
            if (!$scope.$$phase) {
                $scope.$digest();
            }
        }

        //HD ScreenShare Event Listeners
        function onHDScreenShareConfCallConnecting() {
            if (helperService.isFullScreen()) {
                self.onStartLoading({}, { type: 'hdScreenshare' }, true);
            }
        }

        function onHDScreenShareConfCallConnected() {
            if (self.state !== 'show') {
                return;
            }

            $timeout(function () {
                self.onStopLoading({}, { type: 'hdScreenshare' });
            }, helperService.getAddMemberKeyFrameDelay());
        }

        function onHDScreenShareConfCallDisconnected() {
            if (self.state !== 'show') {
                return;
            }

            $timeout(function () {
                self.onStopLoading({}, { type: 'hdScreenshare' });
            }, helperService.getAddMemberKeyFrameDelay());
        }

        function onContentInitiating(e, data) {
            if (!(data && data.type === 'screenshare' && self.sfuScreenShareReconnecting)) {
                self.onStartLoading(e, data);
            }
        }
    }
]);
